<div>
    <h5 class="rps-heading-five">{{feeType}}-specific fees</h5>
    <span *ngIf="feeList && feeList.length>0; else noTableData">
        <div *ngFor="let fee of feeList" [class.fee-item-border-last]="fee.label ==='Load'">
            <div *ngIf="fee.label != '12b-1 fee' && fee.label != 'Transaction fee'" class="fee-item fee-item-border">
                <span>
                    <p>{{fee.label}}</p>
                </span>
                <span>
                    <p [attr.data-rpa-tag-id]="setFeeRpaTag(fee.label)">{{fee.content}}</p>
                </span>
            </div>
            <div *ngIf="fee.label === '12b-1 fee'" class="fee-item fee-item-border">
                <span>
                    <p><a class="link" href="javascript:void(0)" role="button"
                            (click)="setDialogInfo('12b-1 Fee');feesDialog.openModalDialog()">{{fee.label}}</a></p>
                </span>
                <span>
                    <p data-rpa-tag-id="pf-fsf-12b1Fee">{{fee.content}}</p>
                </span>
            </div>
            <div *ngIf="fee.label === 'Transaction fee'" class="fee-item fee-item-border">
                <span data-rpa-tag-id="fee">
                    <p *ngIf="fee.content === 'None' || !fee.content">{{fee.label}}<sup
                            class="footnote">{{noTransactionFeeFootnote?.id}}</sup></p>
                    <p *ngIf="fee.content !== 'None' && fee.content">{{fee.label}}</p>
                </span>
                <span data-rpa-tag-id="fee">
                    <p class="secYieldLink" *ngIf="fee.content === 'See commissions schedule'"><a
                            href="https://investor.vanguard.com/client-benefits/brokerage-fees-commissions">{{fee.content}}</a>
                    </p>
                    <p *ngIf="fee.content !== 'See commissions schedule'" [innerHtml]="fee.content"></p>
                </span>
            </div>
            <p class="footnote rps-paragraph-one rps-grey transactionfee-note" *ngIf="fee.note" [innerHtml]="fee.note">
            </p>
        </div>
    </span>
    <p class="footnote rps-paragraph-one rps-grey vanguardbrokerage"
        *ngIf="displayVanguardBrokerageRedemptionFeeContent" [innerHtml]="vanguardBrokerageRedemptionFee?.contentValue">
    </p>
    <p class="footnote rps-paragraph-one rps-grey" *ngIf="profileData?.is529">
        <span class="noteForDisclaimer">Note: All fees are included in the </span>
        <a href="javascript:void(0)" class="dialog-link" role="button"
            (click)="setDialogInfo('Expense ratio');feesDialog.openModalDialog()">expense ratio.</a>
    </p>
</div>

<ng-template #noTableData>
    <p class="no-data">This information is temporarily unavailable.</p>
</ng-template>

<c11n-modal-dialog modalId="feesDialog" [headingText]="dialogTitle" #feesDialog>
    <div c11n-modal-dialog-body>
        <p [innerHTML]="dialogBody"></p>
    </div>
</c11n-modal-dialog>